import { Design } from '../../../types';
import { deepReplaceValues, findDuplicates } from '../object';

export function parseCommonModule(rawCommonModule: Design) {
  const serializedIntents = JSON.parse(JSON.stringify(window.apm.serialized.components.intents));
  const replaceIds = findDuplicates(rawCommonModule.components.intents, serializedIntents, 'name', 'id');

  const commonModule = {
    ...rawCommonModule,
    components: {
      ...rawCommonModule.components,
      // Remove the intents that will be replaced.
      intents: rawCommonModule.components.intents.filter((intent) => {
        return !replaceIds.has(intent.id);
      })
    }
  };

  // Replace the ids in the common module with the ids from the serialized intents.
  return deepReplaceValues(commonModule, replaceIds);
}
